<lib-segov-sigepo-dropdown-customizable
[customClass]="'tamanho-dropdown'"
[customClassDropdownButton]="'tamanho-dropdown'">
  <div dropdown class="row" [style]="visualizacaoPdf ? 'padding-right: 1rem; align-items: center; height: 5rem;' : 'padding-right: 1rem; align-items: center; height: 6rem;'">
    <div class="col-2"><img [width]="visualizacaoPdf ? '36' : '40'" src="icons/calendar-event-fill-home.svg" alt="Ícone de calendário"/></div>
    <div class="col-4" [style]="visualizacaoPdf ? 'font-size: 2.875rem;' : 'font-size: 68px;'">
      {{dataApresentada.day.toLocaleString('pt-br', {minimumIntegerDigits: 2,})}}
    </div>
    <div class="col-6" style="text-align: left; text-transform: uppercase;">
      <span style="font-weight: 600;">{{dataApresentada.year}}</span> <br>
      <span style="font-weight: 600; text-transform: capitalize;">{{dataApresentada.monthLong}}</span> <br>
      <span class="weekday-full" style="font-weight:300; text-transform:capitalize">
        {{ dataApresentada.weekdayLong }}
      </span>
      <span class="weekday-short" style="font-weight:300; text-transform:capitalize">
        {{visualizacaoPdf ? dataApresentada.weekdayLong?.split('-')[0] : dataApresentada.weekdayLong }}
      </span>
    </div>
  </div>
  <div body class="tamanho-dropdown-body">
    <app-calendar [dataInicial]="dataApresentada" [Cronogramas]="Cronogramas" (alternarMes)="onMudancaDeMes($event)" (dataClicada)="onClicarData($event)" (redirecionarUltimaEdicao)="redirecionarUltimaEdicao.emit()" />
  </div>
</lib-segov-sigepo-dropdown-customizable>
